<template>
    <div class="product_line_content">
        <tr v-if="loading">
            <td colspan="7" style="padding: 40px;">
                <load-spiner></load-spiner>
            </td>
        </tr>
        <tr v-else class="product_row">
            <td>
                <div class="container">
                    <div class="row">
                        <div class="col-md-4 col-3 art_img">
                            <a :href="art_details">
                                <img :src="image" alt="image" />
                            </a>
                        </div>
                        <div class="col-8 art_info text_desktop">
                            <a :href="art_details">
                                <h5>
                                    <b
                                        ><template v-if="eco">ECO</template>
                                        {{ especieName }}</b
                                    ><br />
                                    {{ varietyName }}
                                    <img
                                        src="/img/logos/Logo-Euro-Agricultura.png"
                                        alt="Logo ECO"
                                        style="width: 20px"
                                        v-if="eco"
                                        title="Producto ecológico"
                                    />
                                </h5>
                            </a>
                            <div class="iconos">
                                <img
                                    v-if="eco"
                                    src="/img/iconos/icon_ecologico.svg"
                                    title="Producto ecológico"
                                />
                                <!--                                <img v-if="isZonaCalida" src="/img/iconos/icon_calida.svg" alt="Producto de zona cálida" title="Producto de zona cálida">-->
                                <!--                                <img v-if="isZonaFria" src="/img/iconos/icon_fria.svg" alt="Producto de zona fría" title="Producto de zona fría">-->
                                <img
                                    v-if="isBpSeleccion"
                                    src="/img/bp_seleccion.svg"
                                    title="Producto recomendado por Babyplant"
                                />
                                <template v-if="injertoName">
                                    <img
                                        src="/img/iconos/icon_injertada.svg"
                                        v-b-tooltip.hover
                                        :title="'injertado en ' + injertoName"
                                        alt="Injertada"
                                    />
                                </template>
                            </div>
                        </div>
                        <div class="col-9 art_info text_mobile">
                            <a :href="art_details">
                                <h5>{{ varietyName }}</h5>
                            </a>
                            <span
                                >Nº Alvéolos por bandeja: {{ alveoliNum }}</span
                            >
                            <br />
                            <span
                                >Semillas por alvéolo:
                                {{ seedsByAlveolus }}</span
                            >

                            <div class="iconos">
                                <img
                                    v-if="eco"
                                    src="/img/iconos/icon_ecologico.svg"
                                />
                                <!--                                <img v-if="isZonaCalida" src="/img/iconos/icon_calida.svg" alt="icon_calida.svg">-->
                                <!--                                <img v-if="isZonaFria" src="/img/iconos/icon_fria.svg" alt="icon_fria.svg">-->
                                <img
                                    v-if="isBpSeleccion"
                                    src="/img/bp_seleccion.svg"
                                />
                                <template v-if="injertoName">
                                    <img
                                        src="/img/iconos/icon_injertada.svg"
                                        v-b-tooltip.hover
                                        :title="'injertado en ' + injertoName"
                                        alt="Injertada"
                                    />
                                </template>
                            </div>
                            <br />
                            <div class="info_block">
                                <span>PRECIO</span>
                                <span>{{ precio }} €</span>
                            </div>

                            <div class="row">
                                <div class="col-6 unidades">
                                    <div class="container">
                                        <div class="row">
                                            <div
                                                class="col-4 icon"
                                                @click="addUnidades(-1)"
                                            >
                                                <span>-</span>
                                            </div>
                                            <div class="col-4 num">
                                                <input
                                                    v-model="unidades"
                                                    type="number"
                                                />
                                            </div>
                                            <div
                                                class="col-4 icon"
                                                @click="addUnidades(1)"
                                            >
                                                <span>+</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-6 semana">
                                    <select
                                        v-model="weekYearLine"
                                        @change="openInfoWindow('dividir_ped')"
                                    >
                                        <option
                                            v-if="
                                                avaiableWeeks[weekYearLine] ===
                                                    undefined
                                            "
                                            :value="weekYearLine"
                                            >Semana
                                            {{
                                                weekYearLine | weekEnvio
                                            }}</option
                                        >
                                        <option
                                            v-for="(value,
                                            week) in avaiableWeeks"
                                            :value="week"
                                            >Semana
                                            {{ week | weekEnvio }}</option
                                        >
                                    </select>
                                </div>
                            </div>

                            <div
                                class="info_block"
                                v-if="this.$root.tipo_cliente != 1"
                            >
                                <span>AHORRO</span>
                                <span>{{ ahorro }} €</span>
                            </div>

                            <div class="info_block">
                                <span>TOTAL</span>
                                <span>{{ total }} €</span>
                            </div>
                        </div>
                        <windows-info
                            v-cloak
                            ref="dividir_ped"
                            back-color="orange"
                            in-cart="true"
                        >
                            <div slot="header">
                                <div class="container div_unidades">
                                    <div class="row">
                                        <div class="col-12 mb-3">
                                            ¿Cuántas bandejas quieres mover a la
                                            <span
                                                style="text-transform: uppercase"
                                                >semana {{ semana }}</span
                                            >?
                                        </div>
                                        <div class="col-6">
                                            <h4>Semana {{ semana }}</h4>
                                        </div>
                                        <div class="col-6">
                                            <div class="container unidades">
                                                <div class="row nums">
                                                    <div
                                                        class="col-4 icon"
                                                        @click="
                                                            --unidadesDiv < 1
                                                                ? (unidadesDiv = 1)
                                                                : ''
                                                        "
                                                    >
                                                        <span>-</span>
                                                    </div>
                                                    <div class="col-4 num">
                                                        <input
                                                            v-model="
                                                                unidadesDiv
                                                            "
                                                            type="number"
                                                        />
                                                    </div>
                                                    <div
                                                        class="col-4 icon"
                                                        @click="
                                                            ++unidadesDiv >
                                                            avaiableWeeks[
                                                                weekYearLine
                                                            ]
                                                                ? (unidadesDiv =
                                                                      avaiableWeeks[
                                                                          weekYearLine
                                                                      ])
                                                                : ''
                                                        "
                                                    >
                                                        <span>+</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div slot="footer">
                                <div class="col-12">
                                    <a
                                        class="button_cart_div_pedido"
                                        @click="setWeek()"
                                    >
                                        <div>
                                            <span>Aceptar</span>
                                        </div>
                                    </a>
                                </div>
                            </div>
                        </windows-info>
                    </div>
                </div>
            </td>
            <td>
                <div class="container line_options_block">
                    <div class="row">
                        <div class="col-6">
                            <div class="selectores">
                                <span>Nº alvéolos por bandeja</span>
                                <div class="selectores-positioner text-center">
                                    <select2 style="width: 100%" disabled>
                                        <option value="">{{
                                            alveoliNum
                                        }}</option>
                                    </select2>
                                </div>
                            </div>
                            <div class="selectores">
                                <span>Nº semillas por alvéolo</span>
                                <div class="selectores-positioner text-center">
                                    <select2 style="width: 100%" disabled>
                                        <option value="">{{
                                            seedsByAlveolus
                                        }}</option>
                                    </select2>
                                </div>
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="selectores">
                                <span>Nº de bandejas</span>
                                <div class="container unidades">
                                    <div class="row nums">
                                        <div
                                            class="col-4 icon"
                                            @click="addUnidades(-1)"
                                        >
                                            <span>-</span>
                                        </div>
                                        <div class="col-4 num">
                                            <input
                                                v-model="unidades"
                                                type="number"
                                            />
                                        </div>
                                        <div
                                            class="col-4 icon"
                                            @click="addUnidades(1)"
                                        >
                                            <span>+</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="selectores">
                                <span>Semana de entrega</span>
                                <div style="width: 43%; float:right">
                                    <select2
                                        class="semana"
                                        v-model="weekYearLine"
                                        @change="openInfoWindow('dividir_ped')"
                                        :config-options="{
                                            minimumResultsForSearch: Infinity
                                        }"
                                        style="width: 100%"
                                    >
                                        <option
                                            v-if="
                                                avaiableWeeks[weekYearLine] ===
                                                    undefined
                                            "
                                            :value="weekYearLine"
                                            >Semana
                                            {{
                                                weekYearLine | weekEnvio
                                            }}</option
                                        >
                                        <option
                                            v-for="(value,
                                            week) in avaiableWeeks"
                                            :value="week"
                                            >Semana
                                            {{ week | weekEnvio }}</option
                                        >
                                    </select2>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 desgloses">
                            <span>Precio bandeja (IVA incluido)</span>
                            <span class="float-right">{{ precio }} €</span>
                            <br v-if="this.$root.tipo_cliente != 1" />
                            <span v-if="this.$root.tipo_cliente != 1"
                                >Ahorro total</span
                            >
                            <span
                                class="float-right"
                                v-if="this.$root.tipo_cliente != 1"
                                >{{ ahorro }} €</span
                            >
                            <br />
                            <template v-if="porcentajePagarAhora === 100">
                                <span><b>Precio total (IVA incluido)</b></span>
                                <span class="float-right"
                                    ><b>{{ total }} €</b></span
                                >
                            </template>
                            <template v-else>
                                <span>Precio total (IVA incluido)</span>
                                <span class="float-right">{{ total }} €</span>
                                <br />
                                <span
                                    ><b
                                        >Pagar ahora
                                        {{ porcentajePagarAhora }}%</b
                                    ></span
                                >
                                <span class="float-right"
                                    ><b>{{ totalNow }} €</b></span
                                >
                            </template>
                        </div>
                    </div>
                </div>
            </td>
            <td class="delete_block align-top pr-1">
                <i class="fa fa-times" @click="removeCart()"></i>
            </td>
        </tr>
    </div>
</template>

<script>
export default {
    props: {
        line: {},
        weeks: {},
        custom: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            loading: false,
            avaiableWeeks: [],

            precio: 0,
            unidadesAux: 0,
            unidadesDiv: 1,
            semana: 0,
            year: 0,
            ahorro: 0,
            total: 0,

            art_details: ""
        };
    },
    computed: {
        unidades: {
            get() {
                return this.unidadesAux;
            },
            set(unidades) {
                if (!this.custom || this.line.min_order === 1) {
                    this.unidadesAux = unidades;
                } else {
                    Vue.toasted.error(
                        "No se puede modificar el número de bandejas de lineas con pedido mínimo",
                        {
                            duration: 3000
                        }
                    );
                }
            }
        },
        image() {
            let image;
            if (!this.custom) {
                image = this.line.articulo.img_verify;
            } else {
                image = this.line.variety.imagen;
            }
            return image;
        },
        eco() {
            let eco;
            if (!this.custom) {
                eco = this.line.ecologico;
            } else {
                eco = this.line.ecologico;
            }
            return eco;
        },
        especieName() {
            let name;
            if (!this.custom) {
                name = this.line.articulo.especie_verify.nombre;
            } else {
                name = this.line.variety.mote.especie.nombre;
            }
            return name;
        },
        injertoName() {
            let name = null;
            if (this.custom) {
                if (this.line.variety_pie) {
                    name =
                        this.line.variety_pie.mote.especie.nombre +
                        " " +
                        this.line.variety_pie.mote.nombre +
                        " " +
                        this.line.variety_pie.nombre;
                }
            }
            return name;
        },
        varietyName() {
            let name;
            if (!this.custom) {
                name = this.line.articulo.nombre;
            } else {
                name = this.line.variety.nombre;
            }
            return name;
        },
        isZonaCalida() {
            let is;
            if (!this.custom) {
                is = !!Object.values(this.line.articulo.zona_actual).find(
                    z => z.zona == "CÁLIDA"
                );
            } else {
                let zonaActual = this.line.variety.zona_actual;
                if (zonaActual) {
                    is = !!Object.values(zonaActual).find(
                        z => z.zona == "CÁLIDA"
                    );
                } else {
                    is = false;
                }
            }
            return is;
        },
        isZonaFria() {
            let is;
            if (!this.custom) {
                is = !!Object.values(this.line.articulo.zona_actual).find(
                    z => z.zona == "FRÍA"
                );
            } else {
                let zonaActual = this.line.variety.zona_actual;
                if (zonaActual) {
                    is = !!Object.values(zonaActual).find(
                        z => z.zona == "FRÍA"
                    );
                } else {
                    is = false;
                }
            }
            return is;
        },
        isBpSeleccion() {
            let is;
            if (!this.custom) {
                is = this.line.articulo.bp_seleccion;
            } else {
                is = this.line.variety.is_bp_seleccion;
            }
            return is;
        },
        seedsByAlveolus() {
            let num;
            if (!this.custom) {
                num = this.line.combinacion.semilla_alveolo;
            } else {
                num = this.line.seeds_by_alveolus;
            }
            return num;
        },
        alveoliNum() {
            let num;
            if (!this.custom) {
                num = this.line.combinacion.bandeja.unidades;
            } else {
                num = this.line.tray.unidades;
            }
            return num;
        },
        porcentajePagarAhora() {
            let percent = 100;
            if (this.custom) {
                percent = this.line.porcentaje_pagar_ahora;
            }
            return percent;
        },
        totalNow() {
            let totalNow = this.total;
            if (this.custom) {
                totalNow = this.line.total_now;
            }
            return totalNow;
        },
        weekYearLine: {
            get() {
                return this.year + "-" + (this.semana + "").padStart(2, "0");
            },
            set(val) {
                this.year = parseInt(val.substring(0, 4));
                this.semana = parseInt(val.substring(5));
            }
        }
    },
    mounted() {
        if (!this.custom) {
            if (this.line.articulo.slug) {
                this.art_details =
                    "/products/" +
                    this.line.articulo.id +
                    "-" +
                    this.line.articulo.slug;
            } else {
                this.art_details = "/products/" + this.line.articulo.id;
            }
        } else {
            this.art_details = "javascript:void(0);";
        }

        this.setProductInfo();
    },
    watch: {
        line: function() {
            this.setProductInfo();
        },
        unidades(val) {
            if (!this.custom || this.line.min_order === 1) {
                this.line.unidades = val;
                this.debouncedUpdate();
            }
        }
    },
    methods: {
        setProductInfo: function() {
            this.semana = this.line.semana;
            this.total = this.line.total;
            this.year = this.line.year;
            this.ahorro = this.line.ahorro;
            if (!this.custom) {
                this.unidadesAux = this.line.unidades;
                this.precio =
                    Math.round((this.line.importe / this.line.unidades) * 100) /
                    100;
                this.getAvaiableWeeks();
            } else {
                this.unidadesAux = this.line.num_trays;
                this.precio =
                    Math.round(
                        (this.line.importe / this.line.num_trays) * 100
                    ) / 100;
            }
            this.loading = false;
        },
        updateCart: function() {
            this.loading = true;
            let params = {
                quantity: this.unidades
            };
            if (!this.custom) {
                params.lineCart_id = this.line.id;
            } else {
                params.custom_cart_line_id = this.line.id;
            }
            axios
                .post("/carrito/update", params)
                .then(response => {
                    Vue.toasted.show(response.data.info, {
                        type: "success",
                        duration: 3000
                    });
                })
                .catch(e => {
                    Vue.toasted.show(
                        e.response.data.info
                            ? e.response.data.info
                            : "Ha habido un error!",
                        {
                            type: "error",
                            duration: 3000
                        }
                    );
                })
                .finally(response => {
                    this.$root.$emit("loadCartInfo");
                });
        },
        gaAddToCart(quantity) {
            const {
                id,
                nombre,
                especie_verify: { nombre: especieNombre }
            } = this.line.articulo;
            ga("ec:addProduct", {
                id, // Product ID (string).
                name: nombre, // Product name (string).
                category: especieNombre, // Product category (string).
                brand: "Babyplant", // Product brand (string).
                quantity
                //'variant': 'gray',                  // Product variant (string).
                //'position': 2                       // Product position (number).
            });

            ga("ec:setAction", "add");
            ga("ec:setAction", "add_to_cart"); // Detail action.
            ga('send', 'event', 'Ecommerce', 'Add to Cart');
        },
        gaRemoveFromCart() {
            const data = this.line.variety ? this.line.variety : this.line.articulo
            ga("ec:addProduct", {
                id: data.id, // Product ID (string).
                name: data.nombre, // Product name (string).
                category: data.mote.nombre, // Product category (string).
                brand: "Babyplant" // Product brand (string).
                //'variant': 'gray',                  // Product variant (string).
                //'position': 2                       // Product position (number).
            });

            ga("ec:setAction", "remove");
            ga("ec:setAction", "remove_from_cart"); // Detail action.
            ga('send', 'event', 'Ecommerce', 'Remove from Cart');
        },
        removeCart: function() {
            this.loading = true;
            let params = {};
            if (!this.custom) {
                params.lineCart_id = this.line.id;
            } else {
                params.custom_cart_line_id = this.line.id;
            }
            axios
                .post("/carrito/delete", params)
                .then(response => {
                    this.gaRemoveFromCart();
                    Vue.toasted.show(response.data.info, {
                        type: "success",
                        duration: 3000
                    });
                })
                .catch(e => {
                    Vue.toasted.show("Ha habido un error!", {
                        type: "error",
                        duration: 3000
                    });
                })
                .finally(response => {
                    this.$root.$emit("loadCartInfo");
                });
        },
        getAvaiableWeeks: function() {
            axios
                .post("/carrito/avaiable-week", {
                    lineCart_id: this.line.id
                })
                .then(response => {
                    this.avaiableWeeks = response.data;
                })
                .catch(e => {
                    console.log(e);
                });
        },
        setWeek: function() {
            if (this.line.semana === this.semana) {
                return;
            } else if (this.avaiableWeeks[this.weekYearLine]) {
                this.loading = true;
                axios
                    .post("/carrito/set-week", {
                        line_id: this.line.id,
                        week: this.semana,
                        year: this.year,
                        unidades: this.unidadesDiv
                    })
                    .then(response => {
                        this.$root.$emit("loadCartInfo");
                    })
                    .catch(e => {
                        console.log(e);
                    });
            } else {
                this.semana = this.line.semana;
                this.year = this.line.year;
                Vue.toasted.show(
                    "Disculpa. No hay existencias para esta semana.",
                    {
                        type: "error",
                        duration: 3000
                    }
                );
            }
        },
        openInfoWindow: function(ventana) {
            var window = this.$refs[ventana];
            window.active = true;
            this.unidadesDiv = 1;
        },
        addUnidades(unidades) {
            unidades < 0 ? this.gaRemoveFromCart() : this.gaAddToCart(unidades);
            if (!this.custom || this.line.min_order === 1) {
                this.unidades += unidades;
            } else {
                Vue.toasted.error(
                    "No se puede modificar el número de bandejas de lineas con pedido mínimo",
                    {
                        duration: 3000
                    }
                );
            }
        }
    },
    created() {
        this.debouncedUpdate = _.debounce(this.updateCart, 500);
        this.setProductInfo();
    }
};
</script>

<style scoped>
@media (min-width: 1200px) {
    .line_options_block {
        max-width: 1300px;
    }
}

#cart_section .gestionar_orders_block .product_row td:first-child {
    width: 29%;
}

.selectores-positioner {
    width: 30%;
    float: right;
    display: inline-block;
}

.selectores-positioner select {
    width: 100%;
}
</style>
